export default {"src":"/_next/static/media/lightning.10ecfb91.png","height":512,"width":512,"blurWidth":0,"blurHeight":0};